/* ==========================================================================
   WonderBuddy StoryBox Mini product pages.

   Its own script, separate from the Divine PDP's wb-pdp.js, so the two
   product pages can diverge without one breaking the other.

   Three jobs: swap the main photo when a thumbnail is pressed, run the
   quantity stepper, and add to cart without leaving the page. Everything is
   delegated from document, so sections re-rendered by the theme editor keep
   working with no re-binding.
   ========================================================================== */
(function () {
  if (window.wbSbmInit) { return; }
  window.wbSbmInit = true;

  var money = null;

  function closest(el, sel) {
    return el && el.closest ? el.closest(sel) : null;
  }

  /* ---- gallery ---------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var btn = closest(e.target, '[data-sbm-thumbs] button');
    if (!btn) { return; }

    var strip = closest(btn, '[data-sbm-thumbs]');
    var section = closest(btn, '.wb-sbm');
    var main = section && section.querySelector('.sbm-main img');
    var img = btn.querySelector('img');
    if (!main || !img) { return; }

    var full = img.getAttribute('data-full');
    if (full) { main.src = full; }
    if (img.alt) { main.alt = img.alt; }

    strip.querySelectorAll('button').forEach(function (b) {
      b.classList.remove('is-active');
      b.setAttribute('aria-current', 'false');
    });
    btn.classList.add('is-active');
    btn.setAttribute('aria-current', 'true');
  });

  /* ---- quantity --------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var step = closest(e.target, '[data-sbm-step]');
    if (!step) { return; }

    var box = closest(step, '[data-sbm-qty]');
    var out = box && box.querySelector('[data-sbm-qty-value]');
    if (!out) { return; }

    var next = (parseInt(out.textContent, 10) || 1) + parseInt(step.getAttribute('data-sbm-step'), 10);
    if (next < 1) { next = 1; }
    if (next > 99) { next = 99; }
    out.textContent = next;
  });

  /* ---- add to cart ------------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var add = closest(e.target, '[data-sbm-add]');
    if (!add) { return; }
    e.preventDefault();
    if (add.dataset.busy === '1') { return; }

    var id = add.getAttribute('data-variant-id');
    if (!id) { return; }

    /* The stepper lives in the same section; the sticky bar has none, so it
       falls back to one. */
    var section = closest(add, '.wb-sbm');
    var qtyEl = section && section.querySelector('[data-sbm-qty-value]');
    var qty = qtyEl ? (parseInt(qtyEl.textContent, 10) || 1) : 1;

    /* wb-cart.js missing (asset not created, or renamed) would
       otherwise throw here and leave the button greyed out forever.
       Fall back to the plain add so the shop still sells. */
    if (!window.wbCart) {
      console.error('[wb] wb-cart.js is not loaded - add-to-cart is running without the cart drawer. Create the asset "wb-cart.js".');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: qty }] })
      }).then(function () { window.location.href = '/cart'; });
      return;
    }
    window.wbCart.busy(add);

    /* wb-cart.js owns the request now. It fires the theme's own
       'shopify:cart:lines-update' before the round trip, which is what makes
       the header count move and the cart drawer slide open - this section used
       to add the item silently and leave the shopper looking at an unchanged
       cart. */
    window.wbCart.add({ id: id, quantity: qty, button: add })
      .then(function () {
        document.dispatchEvent(new CustomEvent('wb-sbm:added'));
        window.wbCart.flash(add, add.getAttribute('data-added') || 'Added');
      })
      .catch(function (error) {
        /* Never strand the button. The message is Shopify's own where there
           is one ("All 3 are in your cart"), which is more use than a silent
           bounce to the cart page. */
        window.wbCart.fail(add, error && error.message);
      });
  });

  /* ---- playlist audio samples -------------------------------------------
     One <audio> per section, reused by whichever card is playing. Starting a
     second sample therefore stops the first for free, with no bookkeeping,
     and five cards cost one element instead of five. */
  document.addEventListener('click', function (e) {
    var btn = closest(e.target, '[data-sbm-pl-play]');
    if (!btn) { return; }

    var scope = closest(btn, '[data-sbm-pl]');
    var audio = scope && scope.querySelector('[data-sbm-pl-audio]');
    var src = btn.getAttribute('data-src');
    if (!audio || !src) { return; }

    function clearAll() {
      scope.querySelectorAll('[data-sbm-pl-play]').forEach(function (b) {
        b.classList.remove('is-playing');
        b.setAttribute('aria-pressed', 'false');
      });
    }

    /* Identity is the BUTTON, not the file. Keying this on the URL would
       treat two playlists that happen to share a sample as the same card, so
       pressing the second would toggle the first one off instead of playing. */
    if (audio.wbOwner === btn && !audio.paused) {
      audio.pause();
      clearAll();
      return;
    }

    clearAll();
    if (audio.getAttribute('src') !== src) { audio.src = src; }
    audio.wbOwner = btn;
    audio.currentTime = 0;

    var playing = audio.play();
    if (playing && playing.then) {
      playing.then(function () {
        btn.classList.add('is-playing');
        btn.setAttribute('aria-pressed', 'true');
      }).catch(function () {
        /* Autoplay policy or a bad URL: leave every button in the resting
           state rather than showing a pause icon on silence. */
        clearAll();
      });
    } else {
      btn.classList.add('is-playing');
      btn.setAttribute('aria-pressed', 'true');
    }

    /* Bound once. Whenever the shared player stops for ANY reason - the clip
       ended, another card took it over, the OS paused it - every button in
       this section goes back to showing a play icon.

       Deferred by a tick because swapping the source of a playing element
       fires a transient 'pause' on the way to playing the next sample; acting
       on that immediately would wipe the incoming card's own state. */
    if (!audio.dataset.bound) {
      audio.dataset.bound = '1';
      var settle = function () {
        setTimeout(function () { if (audio.paused) { clearAll(); } }, 0);
      };
      audio.addEventListener('ended', settle);
      audio.addEventListener('pause', settle);
    }
  });

  /* ---- looping video row ------------------------------------------------
     The markup holds ONE set of cards; the clones are added here.

     How many copies is computed, not fixed. The loop works by shifting the
     scroll position by exactly one period, which is only possible when the
     scrollable range is at least two periods wide - otherwise the shift lands
     out of bounds, the browser clamps it, and the row simply sticks at the
     end. A few short cards in a wide viewport fail that test, so a period is
     the set repeated however many times it takes to exceed the viewport.

     Layout: [k sets of clones][the real set + k-1 clone sets][k sets of
     clones]. Resting at scrollLeft = one period therefore shows the REAL
     cards, which is what the theme editor highlights and what screen readers
     reach - the clones are inert either side. */
  function buildLoop(wrap) {
    var row = wrap.querySelector('[data-sbm-rv-row]');
    if (!row || !wrap.hasAttribute('data-loop')) { return; }

    var originals = wrap._originals;
    if (!originals) {
      originals = Array.prototype.slice.call(row.children);
      wrap._originals = originals;
    }
    if (originals.length < 2) { return; }

    Array.prototype.slice.call(row.querySelectorAll('[data-clone]'))
      .forEach(function (n) { n.remove(); });

    /* Measured from the cards, NOT from row.scrollWidth: scrollWidth never
       reports less than clientWidth, so a set narrower than the viewport
       measures as the viewport and the copy count comes out far too low.
       Each set's width includes one trailing gap so the sets tile exactly. */
    var gap = parseFloat(getComputedStyle(row).columnGap) || 0;
    var setW = 0;
    originals.forEach(function (el) { setW += el.getBoundingClientRect().width; });
    setW += gap * originals.length;

    var view = row.clientWidth;
    if (!(setW > 0)) { return; }

    var k = Math.max(1, Math.ceil(view / setW));
    var period = setW * k;

    function cloneSet() {
      var frag = document.createDocumentFragment();
      originals.forEach(function (el) {
        var c = el.cloneNode(true);
        c.setAttribute('aria-hidden', 'true');
        c.setAttribute('data-clone', '');
        c.removeAttribute('id');
        Array.prototype.slice.call(c.querySelectorAll('button, a, video, iframe'))
          .forEach(function (b) { b.setAttribute('tabindex', '-1'); });
        frag.appendChild(c);
      });
      return frag;
    }

    var i;
    for (i = 0; i < k; i++) { row.insertBefore(cloneSet(), row.firstChild); }
    for (i = 0; i < 2 * k - 1; i++) { row.appendChild(cloneSet()); }

    wrap._period = period;
    var behavior = row.style.scrollBehavior;
    row.style.scrollBehavior = 'auto';
    row.scrollLeft = period;
    row.style.scrollBehavior = behavior;

    if (!wrap.dataset.loopBound) {
      wrap.dataset.loopBound = '1';
      var settling = false;
      var timer = null;

      function wrapNow() {
        var p = wrap._period;
        if (!p || settling) { return; }
        var x = row.scrollLeft;
        var shift = 0;
        if (x < p * 0.5) { shift = p; }
        else if (x > p * 1.5) { shift = -p; }
        if (!shift) { return; }
        var target = x + shift;
        if (target < 0 || target > row.scrollWidth - row.clientWidth) { return; }
        settling = true;
        var b = row.style.scrollBehavior;
        row.style.scrollBehavior = 'auto';
        row.scrollLeft = target;
        row.style.scrollBehavior = b;
        setTimeout(function () { settling = false; }, 0);
      }

      row.addEventListener('scroll', function () {
        if (settling) { return; }
        var maxSL = row.scrollWidth - row.clientWidth;
        /* Hard against an end: the browser has already clamped, so momentum
           is over and there is nothing left to wait for. Waiting anyway is
           what used to strand the row here - a late scroll event from the
           PREVIOUS wrap would keep clearing the settle timer, so it never
           fired and the strip stuck at the end with no card to its right. */
        if (row.scrollLeft <= 1 || row.scrollLeft >= maxSL - 1) {
          clearTimeout(timer);
          wrapNow();
          return;
        }
        /* Anywhere else, wait for scrolling to stop: moving scrollLeft
           mid-drag fights the browser's own momentum and shows as a stutter. */
        clearTimeout(timer);
        timer = setTimeout(wrapNow, 120);
      });

      /* A resize changes the viewport, so it can change how many copies a
         period needs. Rebuild rather than let the loop go out of range. */
      var rt = null;
      window.addEventListener('resize', function () {
        clearTimeout(rt);
        rt = setTimeout(function () { buildLoop(wrap); }, 200);
      });
    }
  }

  /* ---- plain carousel ends ----------------------------------------------
     Only for a row that is NOT looping. A looping row has clones either side
     and never reaches a real end, so it must keep both arrows live; a plain
     one stops at the first and last card, and an arrow that stays lit there
     is a control that visibly does nothing when pressed. */
  function syncEnds(wrap) {
    if (wrap.hasAttribute('data-loop')) { return; }
    var row = wrap.querySelector('[data-sbm-rv-row]');
    if (!row) { return; }
    var prev = wrap.querySelector('[data-sbm-rv-prev]');
    var next = wrap.querySelector('[data-sbm-rv-next]');
    /* 1px of slack: sub-pixel card widths leave scrollLeft a fraction short
       of the true maximum, which would keep "next" live on a row that has
       nothing left to show. */
    var max = row.scrollWidth - row.clientWidth;
    if (prev) { prev.disabled = row.scrollLeft <= 1; }
    if (next) { next.disabled = row.scrollLeft >= max - 1; }
  }

  function bindEnds(wrap) {
    if (wrap.dataset.endsBound) { return; }
    wrap.dataset.endsBound = '1';
    var row = wrap.querySelector('[data-sbm-rv-row]');
    if (!row) { return; }
    row.addEventListener('scroll', function () { syncEnds(wrap); }, { passive: true });
    /* Card widths are a percentage of the row when "Fit N cards" is on, so a
       resize changes what counts as the end. */
    window.addEventListener('resize', function () { syncEnds(wrap); });
  }

  function bindRows(scope) {
    (scope || document).querySelectorAll('[data-sbm-rv]').forEach(function (wrap) {
      buildLoop(wrap);
      bindEnds(wrap);
      syncEnds(wrap);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bindRows(); });
  } else { bindRows(); }
  /* Images settle after load and can change the set width. */
  window.addEventListener('load', function () { bindRows(); });
  document.addEventListener('shopify:section:load', function (e) { bindRows(e.target); });

  /* Arrows move by one card plus its gap. */
  document.addEventListener('click', function (e) {
    var btn = closest(e.target, '[data-sbm-rv-prev], [data-sbm-rv-next]');
    if (!btn) { return; }
    var row = closest(btn, '[data-sbm-rv]').querySelector('[data-sbm-rv-row]');
    var card = row && row.querySelector('.sbm-rv-card');
    if (!row || !card) { return; }
    var step = card.getBoundingClientRect().width + (parseFloat(getComputedStyle(row).columnGap) || 0);
    row.scrollBy({ left: btn.hasAttribute('data-sbm-rv-prev') ? -step : step, behavior: 'smooth' });
  });

  /* ---- play a clip ------------------------------------------------------
     Swaps the thumbnail for the real player on first press and never again,
     so a visitor who scrolls past without watching downloads nothing. */
  document.addEventListener('click', function (e) {
    var btn = closest(e.target, '[data-sbm-rv-play]');
    if (!btn) { return; }

    var frame = closest(btn, '.sbm-rv-frame');
    var tpl = frame && frame.querySelector('[data-sbm-rv-embed]');
    if (!tpl) { return; }

    var poster = frame.querySelector('.sbm-rv-poster');
    var cap = frame.querySelector('.sbm-rv-cap');

    frame.appendChild(tpl.content.cloneNode(true));
    tpl.remove();
    btn.remove();
    if (poster) { poster.remove(); }
    if (cap) { cap.remove(); }

    var v = frame.querySelector('video');
    if (v) { v.play().catch(function () {}); }
  });
})();